import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { toast } from 'sonner';
import { Mail } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SubscriptionForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    objective: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validar que objective esté seleccionado
    if (!formData.objective) {
      toast.error('Error', {
        description: 'Por favor selecciona un objetivo de salud.',
      });
      return;
    }
    
    setIsSubmitting(true);

    try {
      const response = await axios.post(`${API}/subscriptions`, formData);
      
      if (response.status === 201) {
        toast.success('¡Gracias por suscribirte!', {
          description: 'Te enviaremos tu guía personalizada pronto.',
        });
        
        // Limpiar formulario
        setFormData({ name: '', email: '', objective: '' });
      }
    } catch (error) {
      console.error('Error al suscribirse:', error);
      
      if (error.response?.status === 400) {
        toast.error('Error', {
          description: error.response.data.detail || 'Este correo ya está suscrito.',
        });
      } else {
        toast.error('Error', {
          description: 'Hubo un problema al procesar tu suscripción. Intenta de nuevo.',
        });
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="block-light form-section" id="subscribe-form">
      <div className="container">
        <div className="form-container">
          <div className="form-content">
            <div className="form-icon-wrapper">
              <div className="form-icon">
                <Mail size={32} />
              </div>
            </div>
            <h2>Recibe tu guía gratuita de suplementos</h2>
            <p>
              Completa el formulario y recibe recomendaciones personalizadas según tu objetivo de salud.
            </p>

            <form onSubmit={handleSubmit} className="subscription-form">
              <div className="form-field">
                <Label htmlFor="name" className="form-label">Nombre completo</Label>
                <Input
                  id="name"
                  type="text"
                  placeholder="Tu nombre"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  required
                  className="form-input"
                />
              </div>

              <div className="form-field">
                <Label htmlFor="email" className="form-label">Correo electrónico</Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="tu@correo.com"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  required
                  className="form-input"
                />
              </div>

              <div className="form-field">
                <Label htmlFor="objective" className="form-label">Objetivo de salud</Label>
                <Select 
                  value={formData.objective} 
                  onValueChange={(value) => setFormData({ ...formData, objective: value })}
                  required
                >
                  <SelectTrigger className="form-input">
                    <SelectValue placeholder="Selecciona tu objetivo" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="energia">Energía y vitalidad</SelectItem>
                    <SelectItem value="estres">Estrés y descanso</SelectItem>
                    <SelectItem value="digestion">Digestión y microbiota</SelectItem>
                    <SelectItem value="defensas">Defensas y bienestar general</SelectItem>
                    <SelectItem value="belleza">Belleza y longevidad</SelectItem>
                    <SelectItem value="familia">Cuidado familiar y personal</SelectItem>
                  </SelectContent>
                </Select>
              </div>

              <Button 
                type="submit" 
                className="btn-primary form-submit" 
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Enviando...' : 'Recibir guía gratuita'}
              </Button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SubscriptionForm;